export type EmailAuthMode = 'magic' | 'passkey' | 'saml';
export type AuthMethod = EmailAuthMode | 'google' | 'microsoft';

export const lastAuthMethodStorageKey = 'countercyclical:last-auth-method';

export function getLastAuthMethod(): AuthMethod | null {
    const storedMethod = localStorage.getItem(lastAuthMethodStorageKey);

    if (
        storedMethod === 'magic' ||
        storedMethod === 'passkey' ||
        storedMethod === 'saml' ||
        storedMethod === 'google' ||
        storedMethod === 'microsoft'
    ) {
        return storedMethod;
    }

    return null;
}

export function isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(email);
}
